/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { mediaQuery } from 'utils/styles';
import { aniFrameCountdownBarInitial } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/initial';
import { aniFrameCountdownBarResult } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/result';
import { aniProgressBarShareTopInitial } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/initial';
import { aniProgressBarShareTopResult } from 'components/content/shared/questionset/shared/animations/progressbar_share_top/result';
import { aniQuestionInitial } from 'components/content/shared/questionset/shared/animations/question/initial';
import { aniQuestionResult } from 'components/content/shared/questionset/shared/animations/question/result';
import {pxToEm} from "../../../../../utils/styles";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMOJI QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
// emojis used are here https://twitter.github.io/twemoji/preview.html
export default {
    resultelements: {},
    answerset: {},
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            '& ul': {
                width: '100%',
                height: '85%',
                textAlign: 'center'
            },
            // animations
            '& .answer': {
                display: 'inline-block',
                verticalAlign: 'top',
                textAlign: 'center',
                width: '32%',
                height: '100%',
                marginRight: '1%',

                opacity: '0',
                animationName: 'rollIn',
                animationDuration: '.4s',
                animationFillMode: 'forwards',

                '&:nth-child(1)': { animationDelay: '1.0s' },
                '&:nth-child(2)': { animationDelay: '1.1s', animationDuration: '.4s' },
                '&:nth-child(3)': { animationDelay: '1.3s', animationDuration: '.4s' },
                '&:nth-child(4)': { animationDelay: '1.5s', animationDuration: '.5s' },

                '&:last-child': {
                    marginRight: '0'
                },
                '&:hover': {
                    '& .emoji': {
                        animationName: 'pulse',
                        animationDelay: '0s',
                        animationDuration: '.5s'
                    }
                }
            },
            // amount of answers change the styles (ex 2 answers vs 4 answers)
            '&.answeramount-2': {
                fontSize: '120%',
                '& .answer': { width: '46%' },
                '& .answer .graphic': { fontSize: '110%' }
            },
            '&.answeramount-4': {
                fontSize: '85%',
                '& .answer': { width: '23%' },
                '& .answer .graphic': { fontSize: '90%' }
            }
        },

        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniProgressBarShareTopInitial],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameCountdownBarInitial, aniQuestionInitial],
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],
            '& .answerset': {
                '& .answer': {
                    '& .graphic': {
                        transition: 'transform .7s linear .1s',
                        transform: 'scale(.7) translate(0%, -85%)',
                        '& .fade': {
                            // animates color fade to show correct/incorrect choice
                            animationName: 'fadeIn',
                            animationDelay: '.5s',
                            animationDuration: '.7s',
                            animationFillMode: 'forwards'
                        }
                    },
                    '& .percentagebar': {
                        width: '60%',
                        height: '48%'
                    }
                }
            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            // extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],

            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        typeset: {
            '& .answerset': {
                fontSize: '110%',
                '&.answeramount-4': {
                    fontSize: '105%',
                    '& .answer .graphic': { fontSize: '110%' }
                }
            },
            '&.result': {
                '& .answerset': {
                    '& .answer': {
                        '& .graphic': {
                            transform: 'scale(.8) translate(0%, -75%)'
                        },
                        '& .percentagebar': {
                            height: '45%'
                        }
                    }
                }
            }
        }
    },
    [mediaQuery.medium]: {
        typeset: {
            '& .answerset': {
                fontSize: '100%',
                '&.answeramount-4': {
                    fontSize: '105%',
                    '& .answer .graphic': { fontSize: '95%' }
                }
            }
        }
    },
    [mediaQuery.thin]: {
        typeset: {
            '& .answerset': {
                '&.answeramount-2': { fontSize: '90%' },
                '&.answeramount-3': { fontSize: '90%' },
                '&.answeramount-4': { fontSize: '90%' }
            }
        }
    }
};
